var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11",
    "data-name": "Group 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 111.268,
    height: 97.049,
    viewBox: "0 0 111.268 97.049",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 111.268,
    height: 97.049,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M99.077,2.083a26.739,26.739,0,0,0-20.63-.028A27.8,27.8,0,0,0,63.7,16.243,27.793,27.793,0,0,0,48.947,2.055a26.746,26.746,0,0,0-20.63.028C14.13,8.008,7.211,24.831,12.892,39.583A28.983,28.983,0,0,0,15.5,44.472l3.586,0A31.72,31.72,0,0,1,15.707,38.5c-5.1-13.244,1.078-28.332,13.773-33.634a23.753,23.753,0,0,1,9.169-1.849A24,24,0,0,1,47.8,4.843a24.717,24.717,0,0,1,13.392,13.2,2.691,2.691,0,0,0,5.013,0A24.714,24.714,0,0,1,79.6,4.843a23.752,23.752,0,0,1,18.32.022c12.695,5.3,18.873,20.39,13.773,33.634-4.746,12.325-41.3,48.395-47.99,54.936C59.21,89.051,41.3,71.4,28.559,56.519l-3.939.005C39.1,73.818,61.353,95.372,62.65,96.625a1.507,1.507,0,0,0,2.1,0c1.808-1.746,44.318-42.917,49.758-57.041,5.681-14.752-1.238-31.575-15.425-37.5",
    transform: "translate(-5.221 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M30.624,76l8.758-19L55.34,89.256a1.507,1.507,0,0,0,1.352.839h0a1.507,1.507,0,0,0,1.351-.847L69.393,65.963l5.49,10.081a1.509,1.509,0,0,0,1.312.787l13.468.109h.013a1.508,1.508,0,0,0,.012-3.016l-12.581-.1-6.465-11.87a1.523,1.523,0,0,0-1.358-.786,1.506,1.506,0,0,0-1.321.847L56.682,85.166l-16-32.333a1.508,1.508,0,0,0-1.352-.839h-.021a1.508,1.508,0,0,0-1.348.877L28.289,73.863,1.506,73.9a1.508,1.508,0,0,0,0,3.016h0l27.747-.041A1.507,1.507,0,0,0,30.624,76",
    transform: "translate(0 -24.894)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.8aa7988f64a425b4879e22207142e6f6.svg";
export { ForwardRef as ReactComponent };